import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../configs/store';
import Form  from '../../Form/Form';

interface BlockedCustomerProps {
  close: () => void
}

function BlockedCustomer({ close }: BlockedCustomerProps) {
  const { t } = useTranslation('common');
  const history = useHistory();
  const { confirmationMessage } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (confirmationMessage) {
      history.push('#confirmation-message');
    }
  }, [confirmationMessage]); // eslint-disable-line react-hooks/exhaustive-deps

  const steps = [
    {
      inputs: [
        {
          type: 'text',
          className: 'full-width',
          label: t('form.usernameOrEmailLabel'),
          name: 'emailOrUsername',
          placeholder: t('form.usernameOrEmailLabel'),
          required: true
        }
      ],
      buttons: [
        {
          className: 'modal-submit',
          type: 'submit',
          label: t('form.resetPassword')
        }
      ]
    }
  ];

  return (
    <Form
      containerClass="forgotPassword-form"
      steps={ steps }
      close={ close }
    />
  );
}

export default BlockedCustomer;
